import { TypeOfApp } from '~/graphql/__generated__/operations/ltms';

const DICTIONARIES = {
  en: {
    alias: 'Project Alias',
    any_projects: 'Any Projects',
    bank_account_holder: 'Bank Account Holder',
    bank_account_number: 'Bank Account Number',
    bank_branch_name: 'Bank Branch Name',
    bank_name: 'Bank Name',
    cluster: 'Cluster',
    code: 'Project Code',
    dedicated: 'Dedicated',
    enable_tiering: 'Enable Tiering',
    multidrop: 'Multidrop',
    multipickup: 'Multipickup',
    multipickup_multidrop: 'Multipickup Multidrop',
    name: 'Project Name',
    no: 'Project No.',
    oncall: 'Oncall',
    payment_schedule: 'Payment Schedule',
    payment_schedule_time: 'Payment Schedule Time',
    project: 'Project',
    projects: 'Projects',
    shipper_name: 'Shipper Name',
    shipper: 'Shipper Project',
    single: 'Single',
    sla_latest_drop_time: 'SLA Latest Drop Time',
    type: 'Project Type',
    working_days: 'Working Days',
    type_of_app: 'Type Of App',
    type_of_app_map: {
      [TypeOfApp.WaBot]: 'WA BOT',
      [TypeOfApp.Flynd]: 'FLYND',
      [TypeOfApp.NonApp]: 'NON APP',
    },
  },
};

export default DICTIONARIES;
